import React from 'react';
import { NavigateFunction } from 'react-router';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { IDashboardRequestSummaryByStatus } from '@interfaces/platform/platformDashboard';

import { routes } from '@constants/routes';
import { columnSizes } from '@constants/table';

import ViewOrganisationTableCell from '../ViewOrganizationTableCell';

const { adminPanel: { index, organisations } } = routes;

export const getColumns = ({
	navigate,
	statusTitle = '',
}: {
	navigate: NavigateFunction;
	statusTitle: string;
}) => ([
	{
		header: 'Organisation',
		accessorKey: 'assetOwnerName',
		size: columnSizes.size300,
		cell: ({ row }: CellContext<IDashboardRequestSummaryByStatus, any>) => {
			const { name, id, avatar } = row?.original.organization || {};

			const openOrganisationProfile = () => {
				if (!id) return;

				navigate(`${index}${organisations}/organisation-profile/${id}`);
			};

			return (
				<ViewOrganisationTableCell
					avatarId={avatar?.id}
					onClick={openOrganisationProfile}
					text={name}
					tooltipLabel='Company profile'
				/>
			);
		},
	},
	{
		header: `${statusTitle} requests`,
		accessorKey: 'requestCount',
		cell: ({ getValue }: CellContext<IDashboardRequestSummaryByStatus, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value} />;
		},
	},
]);
